import { Routes } from '@angular/router';
import { AuthGuard } from 'src/app/auth/helpers';

export const MESSAGES_ROUTES: Routes = [
  {
    path: 'Messages',
    loadComponent: () =>
      import('./messages/messages.component').then(m => m.MessagesComponent),
    canActivate: [AuthGuard],
  },
];
